module.exports = __webpack_public_path__ + "media/images/img_google-d4c9b9d8a12d18b20d0f6947e3c45c34.png";